import React, { useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NotePageHeader from './NotePageHeader';
import apiClient from '../services/apiClient';
import MarketListingForm from './MarketListingForm';
import { t } from '../i18n';
import './MarketPage.css';

function MarketPublishPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const studyKind = params.get('studyKind') === 'vocabulary' ? 'vocabulary' : 'standard';
  const editorRef = useRef(null);
  const back = () => navigate(studyKind === 'vocabulary' ? '/market?studyKind=vocabulary' : '/market');
  return (
    <div className="note-composer-page market-publish-page">
      <NotePageHeader title={t('market.publish')} description={t('market.publishHelp')} backLabel={t('market.backToMarket')}
        onBack={() => editorRef.current ? editorRef.current.requestCancel() : back()} />
      <MarketListingForm
        ref={editorRef}
        listing={{ studyKind }}
        publishing
        onCancel={back}
        onSave={(form) => apiClient.publishLibraryMarketListing(form)}
        onSaved={(listing) => navigate(`/market/${encodeURIComponent(listing.id)}`, { replace: true })}
      />
    </div>
  );
}

export default MarketPublishPage;
